import { useTranslation } from '@conekta/cronos/i18n';
import { getXprops } from 'app/helpers/getXprops';
import { truncateString } from 'app/util/strings';
import get from 'lodash.get';
import { useContext } from 'react';
import { DefaultTheme, ThemeContext } from 'styled-components';

import { ParagraphMethod } from '../styled-components/ParagraphMerchant';

const T_ROOT = 'bankTransferInformation';

const BankTransferInformation = () => {
  const { t } = useTranslation();

  const THEME_CONTEXT: DefaultTheme = useContext(ThemeContext);
  const { font } = THEME_CONTEXT.colors;

  const xprops = getXprops();
  const bankTransferTextRequested: string = get(xprops, 'options.paymentMethodInformation.bankTransferText', '');

  return (
    <ParagraphMethod color={font} className="FormBankTransfer__BankTransferInformation">
      {bankTransferTextRequested ? truncateString(bankTransferTextRequested) : t(`${T_ROOT}.text`)}
    </ParagraphMethod>
  );
};

export default BankTransferInformation;
